import { c as _c } from "react/compiler-runtime";
import type { ApiNode, ApiNodeData, ApiNodeDataConditional, NodeExecutionDetailConditional } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
import RuleTraceRow from '../rule-trace-row';
type ConditionalNodeBranchProps = {
  context: NodeExecutionDetailConditional;
  node?: ApiNode;
  isFirstEntry: boolean;
  isLastEntry: boolean;
};
const isConditionalNode = (node: ApiNodeData): node is ApiNodeDataConditional => {
  return node.kind === 'conditional';
};
const ConditionalNodeBranch = t0 => {
  const $ = _c(29);
  const {
    context,
    isFirstEntry,
    isLastEntry,
    node
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "onboardings.onboardingTrace"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  let T0;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[1] !== context.branchResults || $[2] !== context.outcomeBranchName || $[3] !== node || $[4] !== t) {
    let t6;
    if ($[10] !== context.outcomeBranchName) {
      t6 = branch => branch.branchName === context.outcomeBranchName;
      $[10] = context.outcomeBranchName;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    const branchTaken = context.branchResults.find(t6);
    const triggeredRules = branchTaken?.results.filter(_temp);
    let t7;
    if ($[12] !== node) {
      t7 = node && isConditionalNode(node) ? node : undefined;
      $[12] = node;
      $[13] = t7;
    } else {
      t7 = $[13];
    }
    const conditionalNodeData = t7;
    const isDefaultBranch = context.outcomeBranchName === conditionalNodeData?.defaultBranch?.name;
    const isSandboxOutcome = !triggeredRules?.length && !isDefaultBranch;
    let t8;
    if ($[14] !== conditionalNodeData || $[15] !== isSandboxOutcome || $[16] !== t) {
      t8 = () => {
        if (isSandboxOutcome) {
          return t(_temp2);
        }
        if (conditionalNodeData?.name) {
          return t(_temp3, {
            name: conditionalNodeData.name
          });
        }
        return t(_temp4);
      };
      $[14] = conditionalNodeData;
      $[15] = isSandboxOutcome;
      $[16] = t;
      $[17] = t8;
    } else {
      t8 = $[17];
    }
    const getNoRulesTriggeredMessage = t8;
    T0 = RuleTraceRow;
    t2 = Boolean(triggeredRules?.length);
    t3 = conditionalNodeData?.name;
    t4 = triggeredRules?.map(_temp5) ?? [];
    t5 = getNoRulesTriggeredMessage();
    $[1] = context.branchResults;
    $[2] = context.outcomeBranchName;
    $[3] = node;
    $[4] = t;
    $[5] = T0;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    T0 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
  }
  let t6;
  if ($[18] !== context.outcomeBranchName) {
    t6 = <span className="text-primary">{context.outcomeBranchName}</span>;
    $[18] = context.outcomeBranchName;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== T0 || $[21] !== isFirstEntry || $[22] !== isLastEntry || $[23] !== t2 || $[24] !== t3 || $[25] !== t4 || $[26] !== t5 || $[27] !== t6) {
    t7 = <T0 triggered={t2} name={t3} conditions={t4} noTriggerLabel={t5} isFirstEntry={isFirstEntry} isLastEntry={isLastEntry} outcome={t6} />;
    $[20] = T0;
    $[21] = isFirstEntry;
    $[22] = isLastEntry;
    $[23] = t2;
    $[24] = t3;
    $[25] = t4;
    $[26] = t5;
    $[27] = t6;
    $[28] = t7;
  } else {
    t7 = $[28];
  }
  return t7;
};
export default ConditionalNodeBranch;
function _temp(r) {
  return r.result;
}
function _temp2($) {
  return $.rulesNotEvaluated;
}
function _temp3($_0) {
  return $_0.rulesExecutedNonTriggeredName;
}
function _temp4($_1) {
  return $_1.rulesExecutedNonTriggered;
}
function _temp5(r_0) {
  return r_0.ruleExpression;
}